export default {
  name: 'Liquidity Buckets |||| Liquidity Buckets',
  title: 'Report "Virtual Liquidity Position"',
  alertText:
    'This screen displays a projected liquidity position. It does not reflect real-time bank account balances but simulates the internal allocation expected based on transactional flow.',
  loading: 'Loading...',
  subtitle: `System data as of %{responseTime}`,
};
